import { Skeleton, Typography } from '@client/toolkit';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MetricCard } from '../../components/metric-card';
import { TiWarning } from 'react-icons/ti';

export function ExpiringContractCard({
  title,
  value,
  isCritical,
  loading,
}: {
  title: string;
  value: number;
  isCritical?: boolean;
  loading?: boolean;
}) {
  const { t } = useTranslation('reporting');
  return (
    <MetricCard title={title} titleClassName={isCritical ? 'text-brand-primary' : ''}>
      <span className={classNames('flex gap-2', isCritical ? 'items-center' : 'items-baseline')}>
        <Typography variantFontSize="h2" className={isCritical ? 'text-brand-primary' : 'text-white'}>
          {loading ? <Skeleton variant="text" className="w-[120px]" /> : value}
        </Typography>
        <div className="flex flex-col">
          {isCritical && <TiWarning size={13} className="text-brand-primary" />}
          <Typography variantFontSize={'sub'} className={'text-white/60'}>
            {isCritical ? t('critical') : t('items')}
          </Typography>
        </div>
      </span>
    </MetricCard>
  );
}
